import { useCountUp } from '../lib/useCountUp';

interface Props {
  value: number;
  format?: (n: number) => string;
  decimals?: number;
  duration?: number;
  trigger?: number;
  className?: string;
}

export function CountUp({
  value,
  format = (n) => n.toLocaleString('en-US'),
  decimals = 0,
  duration = 1100,
  trigger = 0,
  className,
}: Props) {
  const v = useCountUp(value, { duration, decimals, trigger });
  return <span className={'num ' + (className ?? '')}>{format(v)}</span>;
}
